import * as React from "react";
import { SlidingToggle } from "../../SlidingToggle";
import { ServiceSource } from "../serviceHistoryList.utils";

/** NuBrakes or Carfax, each with its card count. */
export const SourceToggle: React.FC<{
  value: ServiceSource;
  onChange: (next: ServiceSource) => void;
  counts?: Partial<Record<ServiceSource, number>>;
}> = ({ value, onChange, counts = {} }) => {
  const count = (source: ServiceSource) =>
    counts[source] ? (
      <span style={{ fontSize: "0.625rem", fontWeight: 400, opacity: 0.75 }}>{counts[source]}</span>
    ) : null;
  return (
    <div className="px-4 py-2">
      <SlidingToggle<ServiceSource>
        options={[
          { value: ServiceSource.NUBRAKES, label: "NuBrakes", adornment: count(ServiceSource.NUBRAKES) },
          { value: ServiceSource.CARFAX, label: "Carfax", adornment: count(ServiceSource.CARFAX) },
        ]}
        value={value}
        onChange={onChange}
        ariaLabel="Service history source"
        floating
      />
    </div>
  );
};
